import { API_CONFIG, FranchiseData } from '../config/api'

export class FranchiseService {
  private static instance: FranchiseService
  private franchiseData: FranchiseData | null = null

  private constructor() {}

  public static getInstance(): FranchiseService {
    if (!FranchiseService.instance) {
      FranchiseService.instance = new FranchiseService()
    }
    return FranchiseService.instance
  }

  public async getFranchiseData(): Promise<FranchiseData> {
    if (this.franchiseData) {
      return this.franchiseData
    }

    try {
      const response = await fetch(
        `${API_CONFIG.BASE_URL}/franchises/${API_CONFIG.FRANCHISE_ID}`,
        {
          headers: {
            'x-api-key': API_CONFIG.API_KEY,
            'Content-Type': 'application/json',
          },
        }
      )

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      this.franchiseData = await response.json()
      return this.franchiseData!
    } catch (error) {
      console.error('Error fetching franchise data:', error)
      // Return fallback data if API fails
      return this.getFallbackData()
    }
  }

  private getFallbackData(): FranchiseData {
    return {
      id: 402,
      name: 'Agency CMS demo',
      subdomain: 'agencycms',
      topbar_color: '#FFFFFF',
      button_color: '#F464AC',
      main_background_color: '#FBCAEF',
      secondary_background_color: '#EAF2D7',
      accent_color: '#F896C7',
      telephone: '+27616293191',
      emergency_telephone: '+27616293191',
      email: 'support@agencycms.com',
      address: '8 Buiten Street\r\nCape Town City Centre',
      facebook: 'https://www.facebook.com/LocalHolidayDeals',
      instagram: 'https://www.instagram.com/localholidaydeals',
      whatsapp: '+27616293191',
      catch_phrase: 'Take control of your travel website',
      cta_text: 'Our templates are made for travel!',
      logo_url: 'https://d181ahmy4p092n.cloudfront.net/franchises/logos/000/000/402/original/Agency_CMS_Logo_pink_slim.png?1629135346',
      footer_logo_url: 'https://d181ahmy4p092n.cloudfront.net/franchises/footer_logos/000/000/402/original/Agency_CMS_Logo_pink_slim.png?1629135346',
      general_logo_url: 'https://d181ahmy4p092n.cloudfront.net/franchises/general_logos/000/000/402/original/Agency.png?1671081687',
      background_image_url: 'https://d181ahmy4p092n.cloudfront.net/franchises/background_images/000/000/402/original/ryan-christodoulou-Q9xdAzYJQyc-unsplash.jpg?1629135623'
    }
  }

  public applyDynamicStyles(franchiseData: FranchiseData): void {
    const root = document.documentElement
    
    // Apply CSS custom properties for dynamic theming
    root.style.setProperty('--franchise-button-color', franchiseData.button_color)
    root.style.setProperty('--franchise-accent-color', franchiseData.accent_color)
    root.style.setProperty('--franchise-main-bg', franchiseData.main_background_color)
    root.style.setProperty('--franchise-secondary-bg', franchiseData.secondary_background_color)
    root.style.setProperty('--franchise-topbar-color', franchiseData.topbar_color)
  }
} 